// src/services/conversationService.ts
import { AxiosResponse } from 'axios';
import apiClient from './apiClient';

/**
 * チャットの一覧取得 API
 * GET: /conversation/list/
 */
export const getConversationList = async (): Promise<AxiosResponse> => {
  return apiClient.get('/chat/conversation/list/');
};

/**
 * 複数会話を ZIP で取得
 * GET: /chat/conversation/export/?ids=1,2,3
 */
export const exportConversations = async (ids: number[]): Promise<Blob> => {
  const res = await apiClient.get('/chat/conversation/export/', {
    params: { ids: ids.join(',') },
    responseType: 'blob',
  });
  return res.data;
};
